import PERMISSIONS_LIST from 'web-shared/modules/Permissions/permissions-list';
import { portalLevelPermissions } from 'web-shared/modules/Permissions/PortalLevelPermissions';

const useScGoAccess = () => {
  const hasPermission = (permission: PERMISSIONS_LIST) => {
    return portalLevelPermissions.isPermissionEnabled(permission, null);
  };

  const hasScGoCreateShipmentAccess = () => {
    return hasPermission(PERMISSIONS_LIST.sc_go_create_shipment);
  };

  const hasScGoPickupShipmentAccess = () => {
    return hasPermission(PERMISSIONS_LIST.sc_go_pickup_shipment);
  };

  const hasScGoUsdotVerificationAccess = () => {
    return hasPermission(PERMISSIONS_LIST.company_management_page_access)
      && hasPermission(PERMISSIONS_LIST.edit_companies);
  };

  const hasScGoAccess = () => {
    return hasScGoCreateShipmentAccess() || hasScGoPickupShipmentAccess();
  };

  return {
    hasScGoCreateShipmentAccess,
    hasScGoPickupShipmentAccess,
    hasScGoUsdotVerificationAccess,
    hasScGoAccess,
  };
};

export default useScGoAccess;
